module.exports = "<div id=\"paycell-info-dialog\" class=\"modal-style xl-flexbox xl-left\">\n    <div class=\"modal-in paycell-info-dialog\">\n        <button class=\"modal-close-button fizyicon-close-icon-bold\" ng-click=\"$ctrl.close()\" />\n\n        <div class=\"paycell-logo\">\n            <img src=\"" + require("../../../assets/img/Logo_Paycell-L.png") + "\" alt=\"paycell-logo\">\n        </div>\n        <p class=\"paycell-description\" translate>dialog.card.info</p>\n\n      <a href=\"/\" class=\"paycell-detailed-link\">\n\n        </a>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/buy/paycell-info-dialog/paycell-info-dialog.html
// module id = 525
// module chunks = 0